//import Headroom from 'headroom.js';
import dropdownEvent from "../base/_dropdownEvent.js";

export default class Header {
	constructor(node = "header.wp-block-template-part") {
		this.node = typeof node === "string" ? document.querySelector(node) : node;

		if (document.body.classList.contains("home")) {
			this.headerBackground();
			window.addEventListener("scroll", () => {
				this.headerBackground();
			});
		}

		if (!this.node instanceof HTMLElement) {
			return;
		}

		this.isGreater992 = document.body.clientWidth >= 992;

		const matchMedia = window.matchMedia("(min-width: 992px)");

		matchMedia.addEventListener("change", () => {
			this.isGreater992 = document.body.clientWidth >= 992;
		});

		this.desktopMenu();
	}

	headerBackground() {
		if (window.scrollY == 0) {
			this.node.classList.add("site-header--reverse");
			this.node.dataset.isTop = "true";
		} else {
			this.node.classList.remove("site-header--reverse");
			this.node.dataset.isTop = "false";
		}
	}

	desktopMenu() {
		// dropdowns
		const intentActivate = (e) => {
			if (this.isGreater992) {
				document.body.classList.add("fixed");
				document.body.dataset.isOpenMenu = "true";
				this.node.classList.remove("site-header--reverse");

				this.node
					.querySelector(".site-search")
					.classList.remove("site-search--opened");
				this.node
					.querySelector(".site-search__content")
					.classList.remove("site-search__content--opened");
				Array.from(e.target.children)
					.filter((node) => node.classList.contains("nav__menu-sub"))
					.forEach((node) => node.classList.add("nav__menu-sub--opened"));
			}
		};

		const intentDeactivate = (e) => {
			if (this.isGreater992) {
				document.body.classList.remove("fixed");
				document.body.dataset.isOpenMenu = "false";
				if (this.node.dataset.isTop === "true") {
					this.node.classList.add("site-header--reverse");
				}
				this.node
					.querySelector(".nav__menu")
					.classList.remove("nav__menu--has-toggle-active");
				Array.from(e.target.children)
					.filter((node) => node.classList.contains("nav__menu-sub"))
					.forEach((node) => node.classList.remove("nav__menu-sub--opened"));
				Array.from(e.target.children)
					.filter((node) => node.classList.contains("nav__menu-toggle"))
					.forEach((node) => node.classList.remove("toggle-btn--menu--active"));
			}
		};

		Array.from(this.node.querySelectorAll(".nav__menu-item--has-sub")).forEach(
			(node) => {
				dropdownEvent(node);
				node.addEventListener("dropdown:activate", intentActivate);
				node.addEventListener("dropdown:deactivate", intentDeactivate);
			}
		);
	}
}
// if mobile and switch to 992, and nav was open, need to remove fixed body class, remove nav--opened class, remove nav__content--opened
